import barba from '@barba/core';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

import type { LitPopupElement } from '../custom-elements/LitPopupElement/LitPopupElement';

import anchors from '../inits/anchors';
import { lazyload } from '../inits/lazyload';
import reveal from '../inits/reveal';

import splitTextInit from '../inits/split-text';

export function initBaseView() {
    barba.hooks.enter(() => {
        lazyload.update();
    });

    barba.hooks.beforeEnter((data) => {
        ScrollTrigger.refresh();
        document.body.classList.remove('no-scroll');
        setTimeout(() => {
            gsap.to(window, {
                scrollTo: { y: 0 },
                duration: 0,
            });
        }, 50);

        if (data) {
            document.body.classList.add(data.next.namespace);
        }
        reveal.init(data?.next.container);
        anchors.init(data?.next.container);
        splitTextInit(data?.next.container);
    });

    barba.hooks.leave(() => {
        const popups = Array.from(document.querySelectorAll<LitPopupElement>('app-lit-popup'));
        if (popups.length) {
            popups.forEach((popup) => {
                if (popup.instance.isOpen) {
                    popup.close();
                }
                popup.classList.remove('lit-popup--opened');
                popup.classList.remove('is-show');
            });
        }
    });

    barba.hooks.afterLeave((data) => {
        if (data) {
            document.body.classList.remove(data.current.namespace);
        }

        reveal.destroy(data?.current.container);
        anchors.destroy(data?.current.container);
    });
}
